// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.is-loading-image[data-v-2cc3f926] {\n  left: 45%;\n}\n\n/* .is-multiline.dragable-box {\n  min-height: 3em;\n  border: dashed 2px #e3e2e2;\n  border-radius: 2px;\n  margin-left: 2px;\n  margin-right: 3px;\n  background-color: #fafafa;\n} */\n.flex-full-width[data-v-2cc3f926] {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 100%;\n          flex: 0 0 100%;\n}\n\n", ""]);
// Exports
module.exports = exports;
